var map = {
	"./accessibility.png": 9883,
	"./accessibility_2.png": 6636,
	"./aiml-tech-icon.png": 6739,
	"./arrow.png": 4504,
	"./avatar_test.png": 9053,
	"./aws-icon.png": 4264,
	"./azure-icon.png": 3906,
	"./bestpractices.png": 1307,
	"./bestpractices_2.png": 1596,
	"./chakraui.png": 3503,
	"./css.png": 3710,
	"./cta.png": 101,
	"./ctaa.png": 5016,
	"./english.png": 2451,
	"./figma.png": 2607,
	"./framermotion.png": 4606,
	"./german.png": 8349,
	"./git.png": 2355,
	"./github.png": 8870,
	"./graphql.png": 7784,
	"./hero.png": 9227,
	"./hero_bg.png": 6441,
	"./html.png": 132,
	"./icon.png": 6472,
	"./icons8-x-100.png": 4988,
	"./javascript.png": 8098,
	"./laravel-icon.png": 8328,
	"./manish-yadav.png": 2171,
	"./mongodb-icon.png": 403,
	"./mysql-icon.png": 511,
	"./next.png": 3216,
	"./next_2.png": 2947,
	"./node.png": 4759,
	"./photoshop.png": 8635,
	"./php-programming-language-icon.png": 6712,
	"./php.png": 9451,
	"./postgresql-icon.png": 6899,
	"./python.png": 9957,
	"./react.png": 5302,
	"./redux.png": 4573,
	"./rest-api-icon.png": 9454,
	"./sass.png": 8249,
	"./screen5.png": 8490,
	"./seo.png": 4272,
	"./seo_2.png": 4435,
	"./socialpreview.png": 2260,
	"./tailwind.png": 8947,
	"./theodinproject.png": 5791,
	"./typescript.png": 338,
	"./vscode.png": 6765,
	"./vue.png": 5787,
	"./x-icon.png": 5401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2123;